import React, { useState, useImperativeHandle, useRef } from 'react';
import './index.css';
import { useHistory } from "react-router-dom";


export default ({
  relatedTitle = [],
  action,
  isActive = true,  //  是否折叠
  title,
  apiUrl = 'https://cloud.tencent.com/document/product/866/33515',
  consoleUrl = 'https://console.cloud.tencent.com/ocr/overview',
  onChangeAction
}) => {
  const history = useHistory()

  const RelatedTitleCom = () => {
    let com = <></>
    if(relatedTitle.length > 0){
      com = <div className="relatedTitle-container">
      {
        relatedTitle.map(item => (
          <div onClick={() => {
            history.push({search: `action=${item.action}`})
            onChangeAction && onChangeAction(item.action)
          }}
          className={`relatedTitle-item ${action === item.action ? 'isActive' : ''}`}>{item.title}</div>
        ))
      }
      </div>
    }else{
      com = <>
      {
         title && <div className="ocrDemo-header__title">{title}</div>
      }
      </>
    }
    return com
  }
  return (
    <div className="ocrDemo-header-container">
      <div className={`ocrDemo-header__logo-container ${ isActive ? 'isActive' : ''} ${ action ? 'border' : ''}`}>
        <div className={`ocrDemo-header__logo ${ isActive ? 'isActive' : ''}`}></div>
      </div>
      {
        RelatedTitleCom()
      }
      <div className="ocrDemo-header__navItem">
        <span className="ocrDemo-header__logo-api"></span>
        <a href={apiUrl} target="_blank" className="ocrDemo-header__navItem-title">API文档</a>
      </div>
      <div className="ocrDemo-header__navItem">
        <span className="ocrDemo-header__logo-console"></span>
        <a href={consoleUrl} target="_blank" className="ocrDemo-header__navItem-title">控制台</a>
      </div>
    </div>

  );
};